import { Autorenew, PostAdd, Visibility } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { IconButton, Tooltip, } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import moment from "moment";
import { memo } from "react";
import ExportSinietralidadButton from "../../commons/export/ExportarSiniestralidadButton";
import ExportButton from "../../commons/export/ExportButton";
import { tableConfig, tableStyles } from "../../commons/table/tableConfig";
import TitleContainer from "../../commons/table/utilsTable/TitleWithFetchData";
import SiniestroFilterForm from "./SiniestroFilterForm";
import SiniestroTableDetail from "./SiniestroTableDetail";

const SiniestroTable = ({
  data,
  loading,
  fetchData,
  handleSubmitFilter,
  handleAgregarDocumentacion,
  handleEnviarReciboSueldo,
  handleDescargarReportePredenuncia,
  handleOpenSolicitudReingreso,
  handleAdjuntarDenuncia,
  initialValues,
  handleAccidentDetail,
}) => {
  const theme = useTheme();

  const columns = [
    {
      header: "Siniestro",
      accessorKey: "siniestroART",
    },
    {
      header: "DNI",
      accessorKey: "nroDocumento",
    },
    {
      header: "Nombre",
      accessorKey: "apellidoNombre",
    },
    {
      header: "Tipo Siniestro",
      accessorKey: "tipoSiniestro",
    },
    {
      header: "Fecha de Ocurrencia",
      accessorKey: "fechaOcurrencia",

      filterFn: (row, columnId, filterValue) => {
        const cellValue = moment(row.getValue(columnId)).format("DD/MM/YYYY");
        return cellValue.includes(filterValue);
      },
      Cell: ({ row }) =>
        row.original.fechaOcurrencia
          ? moment(row.original.fechaOcurrencia).format("DD/MM/YYYY")
          : "",
    },
    {
      header: "Fecha Próximo Control",
      accessorKey: "fechaProximoControl",
      filterFn: (row, columnId, filterValue) => {
        if (moment(row.getValue(columnId)).format("DD/MM/YYYY").includes(filterValue))
          return true;
        return false;
      },
      Cell: ({ row }) =>
        row.original.fechaProximoControl
          ? moment(row.original.fechaProximoControl).format("DD/MM/YYYY")
          : "",
    },
    {
      header: "Fecha Cese ILT",
      accessorKey: "fechaCeseILT",
      filterFn: (row, columnId, filterValue) => {
        if (moment(row.getValue(columnId)).format("DD/MM/YYYY").includes(filterValue))
          return true;
        return false;
      },
      Cell: ({ row }) =>
        row.original.fechaCeseILT
          ? moment(row.original.fechaCeseILT).format("DD/MM/YYYY")
          : "",
    },
    {
      header: "Fecha de Alta",
      accessorKey: "fechaAlta",
      filterFn: (row, columnId, filterValue) => {
        if (moment(row.getValue(columnId)).format("DD/MM/YYYY").includes(filterValue))
          return true;
        return false;
      },
      Cell: ({ row }) =>
        row.original.fechaAlta
          ? moment(row.original.fechaAlta).format("DD/MM/YYYY")
          : "",
    },
    {
      header: "Fecha de Rechazo",
      accessorKey: "fechaRechazo",
      filterFn: (row, columnId, filterValue) => {
        if (moment(row.getValue(columnId)).format("DD/MM/YYYY").includes(filterValue))
          return true;
        return false;
      },
      Cell: ({ row }) =>
        row.original.fechaRechazo
          ? moment(row.original.fechaRechazo).format("DD/MM/YYYY")
          : "",
    },
  ];

  return (
    <MaterialReactTable
      {...tableConfig}
      columns={columns}
      data={data}
      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      initialState={{ showColumnFilters: true }}
  style={{ ...tableStyles.container }}
      title={
        <TitleContainer title="" noRefresh={false} fetchData={fetchData} />
      }
      renderTopToolbar={() => (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <ExportButton
              data={data}
              color={`${theme.palette.tertiary.main}`}
              columns={[
                ...columns,
                {
                  header: "Modalidad de Denuncia",
                  accessorKey: "modalidadDenuncia",
                },
                {
                  header: "Prestador Inicial",
                  accessorKey: "prestadorInicial",
                },
                {
                  header: "Establecimiento",
                  accessorKey: "establecimiento",
                },
              ]}
              title="Siniestralidad"
            />
            <ExportSinietralidadButton />
          </div>
          <div>
            <SiniestroFilterForm
              handleSubmit={handleSubmitFilter}
              initialValues={initialValues}
            />
          </div>
        </>
      )}
      enableColumnActions={false}
      renderDetailPanel={({ row }) => (
        <div style={{ backgroundColor: "#fafafa" }}>
          <SiniestroTableDetail rowData={row.original} />
        </div>
      )}

      enableRowActions
      positionActionsColumn="last"
      renderRowActions={
        ({ row }) => (
          <>
            <Tooltip title="Ver siniestro">
              <IconButton size="medium" onClick={() => {
                handleAccidentDetail(row.original)
              }}>
                <Visibility />
              </IconButton>
            </Tooltip>
            <Tooltip title="Agregar documentación">
              <IconButton size="medium" onClick={() => {
                handleAgregarDocumentacion(row.original)
              }}>
                <PostAdd
                  style={{
                    color: `${theme.palette.tertiary.main}`,
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Enviar Recibo de Sueldo">
              <IconButton size="medium" onClick={() => {
                handleEnviarReciboSueldo(row.original)
              }}>
                <RequestQuoteIcon
                  style={{ color: `${theme.palette.secondary.main}` }}
                />
              </IconButton>
            </Tooltip>
            {
              // Por especificacion, la funcionalidad de descargar reporte
              // solamente está habilitada para aquellos siniestros
              // que tengan la modalidad "Web"
            }
            <Tooltip title="Descargar reporte de predenuncia">
              <IconButton disabled={row.original.codigoModalidadDenuncia !== 4} size="medium" onClick={() => {
                handleDescargarReportePredenuncia(row.original.nroPreDenuncia)
              }}>
                <SaveAltIcon
                  style={{
                    color: `${row.original.codigoModalidadDenuncia !== 4
                      ? theme.palette.primary.grey
                      : theme.palette.quartary.main
                      }`,
                  }}
                />
              </IconButton>
            </Tooltip>
            {
              // Por especificacion, la funcionalidad de adjuntar denuncia
              // solamente está habilitada para aquellos siniestros
              // que tengan la modalidad "Web"
            }
            <Tooltip title="Adjuntar Denuncia">
              <IconButton disabled={row.original.codigoModalidadDenuncia !== 4} size="medium" onClick={() => {
                handleAdjuntarDenuncia(row.original)
              }}>
                <AttachFileIcon
                  style={{
                    color: `${row.original.codigoModalidadDenuncia !== 4
                      ? theme.palette.primary.grey
                      : "black"
                      }`,
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Solicitud de Reingreso">
              <IconButton size="medium" onClick={() => {
                handleOpenSolicitudReingreso(row.original)
              }}>
                <Autorenew/>
              </IconButton>
            </Tooltip>
          </>
        )
      }
      displayColumnDefOptions={{
        "mrt-row-actions": {
          muiTableHeadCellProps: {
            align: "center",
          },
          header: "",
          minSize: 250,
        },
      }}

      detailPanel={[
        {
          tooltip: "Más Información",
          render: (rowData) => (
            <div style={{ backgroundColor: "#fafafa" }}>
              <SiniestroTableDetail rowData={rowData} />
            </div>
          ),
        },
      ]}
      muiDetailPanelProps={{
        sx: {
          width: '100%',
          '& .MuiCollapse-root': {
            width: '100%',
            minWidth: 0,
          },
        }
      }}
      muiPaginationProps={{
        rowsPerPageOptions: [10, 20, 50, 100],
      }}
    />
  );
};

export default memo(SiniestroTable);
